import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { PersonalVisitFilterComponent } from './component/personal-visit-filter.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatInputModule as MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    PersonalVisitFilterComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    FormsModule,
    ReactiveFormsModule,
    CommonLayoutModule,
    CommonTranslationModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatSelectModule,
    MatInputModule
  ],
  exports: [
    PersonalVisitFilterComponent
  ]
})
export class PersonalVisitFilterModule { }
